<template>
    <v-app>
        <header-card-public ref="refHeader" current_page="careers"></header-card-public>
        
        <v-content class="content-container">
            <v-layout fill-height align-center row wrap>
                <v-flex xs12 sm12 :class="isMobile?'form-container-mobile':'form-container'">
                    <v-card dense style="border-radius:4px;">
                        <v-toolbar flat height="45px">
                            <span class="font-weight-bold subheading">Careers at SweldoNow</span>
                            <v-spacer></v-spacer>
                        </v-toolbar>
                        <v-card-text dense>
                            <v-layout row wrap>
                                <v-flex xs12 sm12>
                                    <p v-html="intro"></p>
                                </v-flex>
                            </v-layout>
                        </v-card-text>  
                    </v-card>
                    <v-card dense style="border-radius:4px;margin-top:20px;">
                        <v-toolbar flat :height="isMobile?'65px':'45px'">
                            <span class="font-weight-bold subheading">Remote Sales Partner – 100% Commission | Earn PHP 50K–150K+ per Client in Year 1</span>
                            <v-spacer></v-spacer>
                        </v-toolbar>
                        <v-card-text dense>
                            <v-layout row wrap>
                                <v-flex xs12 sm12>
                                    <h3>📢 What We're Looking For</h3>
                                        <p>
                                            We are seeking driven, self-motivated Sales Partners to help us expand our customer base across the Philippines. This is a 100% commission-based role — ideal for freelancers, side hustlers, or individuals with an existing sales role in a different industry.
                                            <br><br>
                                            You can work part-time, remotely, and at your own pace. As long as there is no conflict of interest, you don’t need to leave your current job to start earning with SweldoNow.
                                        </p>

                                        <h3>💰 Compensation & Commission Details</h3>
                                        <p><strong>We offer a generous and sustainable commission structure:</strong></p>
                                        <ul>
                                            <li><strong>🔹 1st Year Commission</strong><br>
                                            30% of the customer's 1st payment (paid in staggered release):<br>
                                            - 50% after 1st payment<br>
                                            - 25% after 2nd payment<br>
                                            - 25% after 3rd payment<br>
                                            10% of monthly payments for the next 11 months
                                            </li>
                                            <li><strong>🔹 2nd Year and Onwards</strong><br>
                                            5% recurring monthly commission for as long as the client remains subscribed and you are actively part of the SweldoNow team
                                            </li>
                                            <li><strong>⚠️ Clawback Policy</strong><br>
                                            If a client cancels within the first 3 months, we reserve the right to claw back or adjust the 30% commission accordingly.
                                            </li>
                                        </ul><br>

                                        <h3>📈 Example Commission Potential</h3>
                                        <table border="1" cellspacing="0" cellpadding="8" style="width:100%; border-collapse: collapse; text-align: left;">
                                            <thead style="background-color: #f2f2f2;">
                                            <tr>
                                                <th>Client Size (Users)</th>
                                                <th>Monthly Payment</th>
                                                <th>1st Month Commission</th>
                                                <th>1st Year Earnings</th>
                                                <th>2nd Year Onwards</th>
                                            </tr>
                                            </thead>
                                            <tbody>
                                            <tr>
                                                <td>100 Users</td>
                                                <td>PHP 14,200</td>
                                                <td>PHP 4,260</td>
                                                <td>PHP 19,880</td>
                                                <td>PHP 8,520/year</td>
                                            </tr>
                                            <tr>
                                                <td>300 Users</td>
                                                <td>PHP 40,500</td>
                                                <td>PHP 12,150</td>
                                                <td>PHP 56,700</td>
                                                <td>PHP 24,300/year</td>
                                            </tr>
                                            <tr>
                                                <td>750 Users</td>
                                                <td>PHP 73,500</td>
                                                <td>PHP 22,050</td>
                                                <td>PHP 102,900</td>
                                                <td>PHP 44,100/year</td>
                                            </tr>
                                            </tbody>
                                        </table>
                                        <br>

                                        <h3>🏆 Path to a Full-Time Role</h3>
                                        <p>
                                            High-performing partners who consistently close deals and grow accounts may be invited to join SweldoNow in a full-time capacity with the following benefits:
                                        </p>
                                        <ul>
                                            <li>Monthly fixed salary</li>
                                            <li>Mandatory government benefits (SSS, PhilHealth, Pag-IBIG)</li>
                                            <li>13th month pay</li>
                                            <li>HMO coverage</li>
                                        </ul>
                                        <br>

                                        <h3>✅ What You’ll Do</h3>
                                        <ul>
                                            <li>Manage the full sales cycle — from lead generation to closing contracts</li>
                                            <li>Use LinkedIn Sales Navigator to identify and connect with decision-makers</li>
                                            <li>Reach out via cold calls, personalized emails, and DMs</li>
                                            <li>Conduct product demos to present SweldoNow’s value</li>
                                            <li>Track activity and pipeline using HubSpot CRM</li>
                                            <li>Collaborate with onboarding and support teams</li>
                                            <li>Maintain and grow client relationships for upselling and retention</li>
                                        </ul>
                                        <br>

                                        <h3>🎯 Ideal For</h3>
                                        <ul>
                                            <li>Experienced sales professionals looking for a side hustle</li>
                                            <li>Freelancers with an existing network of business owners</li>
                                            <li>Individuals passionate about modern tech solutions for HR & payroll</li>
                                        </ul>
                                        <br>

                                        <h3>📌 Qualifications</h3>
                                        <ul>
                                            <li>Bachelor’s degree in Business, Marketing, or related field (preferred but not required)</li>
                                            <li>Proven B2B sales or client acquisition experience is a strong advantage</li>
                                            <li>Excellent communication skills in English and Filipino</li>
                                            <li>Confident engaging with decision-makers across BPOs, logistics, tech, etc.</li>
                                            <li>Self-starter who can manage the full sales cycle</li>
                                            <li>Familiarity with payroll, HRIS, or cloud-based SaaS is a plus</li>
                                            <li>Experience with CRM tools like HubSpot</li>
                                            <li>Comfortable using LinkedIn Sales Navigator or similar platforms</li>
                                            <li>Tech-savvy, coachable, and based in the Philippines</li>
                                        </ul>
                                        <br>

                                        <h3>📎 Learn More About SweldoNow</h3>
                                        <ul>
                                            <li><a href="javascript:return false;" @click="$router.push('/')">Product Details</a></li>
                                            <li><a href="https://help.sweldonow.ph" target="_blank">Explore our Knowledge Hub</a></li>
                                            <li><a href="https://help.sweldonow.ph/demo" target="_blank">Watch the product demo</a></li>
                                        </ul>
                                        <br>
                                        
                                        <h3>📩 Ready to Join?</h3>
                                        <p>
                                            Email us your resume at <a href="mailto:sales@sweldonow.ph">sales@sweldonow.ph</a> to get started.
                                        </p>
                                </v-flex>
                            </v-layout>
                        </v-card-text>  
                    </v-card>
                </v-flex>
            </v-layout>
        </v-content>

        <!-- FOOTER -->
        <v-footer dark height="auto">
            <footer-card></footer-card>
        </v-footer>
        
    </v-app>
</template>
<script>

import '@/assets/css/public-FaceAI.css' 

export default {
    name: 'SignUp',
    metaInfo: {
        title: 'Sign Up',
        meta: [
            { charset: 'utf-8' },
            { name: 'description', content: '' },
            { name: 'viewport', content: 'width=device-width, initial-scale=1' }
            ]
    },
    components: {
        'header-card-public': () => import('@/components/HeaderPublic'),
        'footer-card': () => import('@/components/Footer'),
        'sign-up-privacy-link': () => import('@/components/SignUpPrivacyLink')
    },
    data () {
        return {
            loading: false,
            disabled: false,
            error: false,
            errorMessage: null,
            intro: `At SweldoNow, we’re building the future of payroll and HR — 100% cloud-based, mobile-friendly, and designed for modern teams across the Philippines.
                    Whether you're a sales professional, developer, customer success expert, or someone passionate about helping businesses grow, we invite you to explore exciting opportunities to be part of our journey.
                    We are a lean, fast-growing startup looking for partners who are self-driven, resourceful, and committed to results. Join us in delivering simple and scalable payroll solutions that empower Filipino companies.`
            
         }
    },
    methods: {
        goToHome() {
            this.dialogConfirmation = false
            this.$router.push('/')
        },
    },
    created() {},
    computed: {
        isMobile() {
            return window.innerWidth < 600
        },
    },
    destroyed() {},
}
</script>
<style scoped>
.content-container {
    background: 
        linear-gradient(to right, rgb(0, 7, 8, 0.7), rgba(13, 13, 14, 0.1)), 
        url("../assets/landing/landing1.webp");
    height:auto;
    min-height:600px;
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    font-family:Roboto;
}
.form-container {
    margin: 80px 80px 50px 80px;
}
.form-container-mobile {
    margin: 110px 20px 50px 20px;
}
.content1 {
    padding: 0px 20px 0px 20px;
}
.content2 {
    padding: 0px 25px 0px 15px;
}
.content-mobile {
    padding: 0px 25px 0px 20px;
}
.header-intro {
    margin:5px 15px 15px 25px;
}
</style>